import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('tommy_er_address')
export class TommyErAddressEntity {
    @PrimaryGeneratedColumn('increment', {
        name: 'address_id',
    })
    addressId: number

    @Column('varchar', {
        name: 'buy_sheet_ctry'
    })
    buySheetCtry: string


    @Column("varchar", {
        name: 'buy_sheet_chnl',
    

    })
    buySheetChnl: string

    @Column('varchar', {
        name: 'ship_to_address_code',
        

    })
    shipToAddressCode: string

    @Column('text', {
        name: 'ship_to_address',
        nullable: false,
    })
    shipToAddress: string

    @Column('varchar', {
        name: 'ship_mode',
       

    })
    shipMode: string
    @Column('varchar', {
        name: 'delivery_address_code',
       
    })
    deliveryAddressCode: string

    @Column('text', {
        name: 'delivery_address',
        nullable: false,

    })
    deliveryAddress: string

    @Column('varchar', {
        name: 'co_delivery_address_code',

    })
    coDeliveryAddressCode: string

    @Column('text', {
        name: 'co_delivery_address',
        nullable: false,

    })
    coDeliveryAddress: string


    @Column({
        nullable: false,
        name: "is_active",
        default: 1
    })
    isActive: boolean;

    @Column('varchar', {
        nullable: true,
        length: 20,
        name: 'created_user'
    })
    createdUser: string | null;

    @Column('varchar', {
        nullable: true,
        length: 20,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: string;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: string;

    @VersionColumn({
        default: 1,
        name: "version_flag",
    })
    versionFlag: number;


}